/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  PurchasableState,
  PurchasableStateOptional,
  PurchasableStateMetaI,
  PurchasableStateTrackedI,
} from "./purchasable-state";
import {
  PurchasableStateTracked,
  PurchasableStateMeta,
} from "./purchasable-state";

/**
 *
 * @export
 * @interface FixLineItemRequestDTO
 */
export interface FixLineItemRequestDTOOptional {
  /**
   *
   * @type {number}
   * @memberof FixLineItemRequestDTO
   */
  lineItemId?: number;
  /**
   *
   * @type {number}
   * @memberof FixLineItemRequestDTO
   */
  personId?: number;
  /**
   *
   * @type {boolean}
   * @memberof FixLineItemRequestDTO
   */
  fixPurchasable?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof FixLineItemRequestDTO
   */
  fixPurchasableState?: boolean;
  /**
   *
   * @type {PurchasableState}
   * @memberof FixLineItemRequestDTO
   */
  purchasableState?: PurchasableState;
}

export interface FixLineItemRequestDTO extends FixLineItemRequestDTOOptional {
  /**
   *
   * @type {number}
   * @memberof FixLineItemRequestDTO
   */
  lineItemId?: number;
  /**
   *
   * @type {number}
   * @memberof FixLineItemRequestDTO
   */
  personId?: number;
  /**
   *
   * @type {boolean}
   * @memberof FixLineItemRequestDTO
   */
  fixPurchasable?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof FixLineItemRequestDTO
   */
  fixPurchasableState?: boolean;
  /**
   *
   * @type {PurchasableState}
   * @memberof FixLineItemRequestDTO
   */
  purchasableState?: PurchasableState;
}

export interface FixLineItemRequestDTOTrackedI {
  /**
   *
   * @type {number}
   * @memberof FixLineItemRequestDTO
   */
  lineItemId?: number;
  lineItemIdIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof FixLineItemRequestDTO
   */
  personId?: number;
  personIdIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof FixLineItemRequestDTO
   */
  fixPurchasable?: boolean;
  fixPurchasableIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof FixLineItemRequestDTO
   */
  fixPurchasableState?: boolean;
  fixPurchasableStateIsSet: boolean;
  /**
   *
   * @type {PurchasableState}
   * @memberof FixLineItemRequestDTO
   */
  purchasableState?: PurchasableState;
  purchasableStateIsSet: boolean;
}

transformDatesMap.set(
  "FixLineItemRequestDTO",
  function (model: FixLineItemRequestDTO) {},
);

export type FixLineItemRequestDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  lineItemId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  personId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  fixPurchasable: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  fixPurchasableState: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  purchasableState: PropertyMeta<PurchasableStateMetaI>;
}>;

export var FixLineItemRequestDTOMeta: FixLineItemRequestDTOMetaI =
  {} as FixLineItemRequestDTOMetaI;
FixLineItemRequestDTOMeta = typeMeta("FixLineItemRequestDTO", {
  lineItemId: propertyMeta(
    "lineItemId",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  personId: propertyMeta("personId", false, false, false, MetaTypesBase.number),
  fixPurchasable: propertyMeta(
    "fixPurchasable",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  fixPurchasableState: propertyMeta(
    "fixPurchasableState",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  purchasableState: propertyMeta(
    "purchasableState",
    false,
    false,
    false,
    PurchasableStateMeta,
  ),
});

const metaI = FixLineItemRequestDTOMeta;

registerMeta(() => {});

export class FixLineItemRequestDTOTracked implements FixLineItemRequestDTOTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  lineItemId__I?: number = undefined;
  lineItemIdIsSet: boolean = false;
  set lineItemId(v: undefined | number) {
    if (v !== undefined) {
      this.lineItemId__I = v;
      this.lineItemIdIsSet = true;
    } else {
      this.lineItemId__I = v || undefined;
      this.lineItemIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get lineItemId() {
    return this.lineItemId__I;
  }
  personId__I?: number = undefined;
  personIdIsSet: boolean = false;
  set personId(v: undefined | number) {
    if (v !== undefined) {
      this.personId__I = v;
      this.personIdIsSet = true;
    } else {
      this.personId__I = v || undefined;
      this.personIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get personId() {
    return this.personId__I;
  }
  fixPurchasable__I?: boolean = undefined;
  fixPurchasableIsSet: boolean = false;
  set fixPurchasable(v: undefined | boolean) {
    if (v !== undefined) {
      this.fixPurchasable__I = v;
      this.fixPurchasableIsSet = true;
    } else {
      this.fixPurchasable__I = v || undefined;
      this.fixPurchasableIsSet = false;
    }
    this.changeTracker = true;
  }
  get fixPurchasable() {
    return this.fixPurchasable__I;
  }
  fixPurchasableState__I?: boolean = undefined;
  fixPurchasableStateIsSet: boolean = false;
  set fixPurchasableState(v: undefined | boolean) {
    if (v !== undefined) {
      this.fixPurchasableState__I = v;
      this.fixPurchasableStateIsSet = true;
    } else {
      this.fixPurchasableState__I = v || undefined;
      this.fixPurchasableStateIsSet = false;
    }
    this.changeTracker = true;
  }
  get fixPurchasableState() {
    return this.fixPurchasableState__I;
  }
  purchasableState__I?: PurchasableState = undefined;
  purchasableStateIsSet: boolean = false;
  set purchasableState(v: undefined | PurchasableState) {
    if (v !== undefined) {
      this.purchasableState__I = v;
      this.purchasableStateIsSet = true;
    } else {
      this.purchasableState__I = v || undefined;
      this.purchasableStateIsSet = false;
    }
    this.changeTracker = true;
  }
  get purchasableState() {
    return this.purchasableState__I;
  }
  constructor(config?: FixLineItemRequestDTOOptional, options?: AssignOptions) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {}
  assignFrom(
    config: FixLineItemRequestDTOOptional,
    options?: AssignOptions,
  ): FixLineItemRequestDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (
      config.lineItemId &&
      this.lineItemIdApplyFilter(optionsRequired.filter)
    ) {
      this.lineItemId = config.lineItemId;
      if (optionsRequired.unassign) this.lineItemIdIsSet = false;
      else this.lineItemIdIsSet = true;
    }
    if (config.personId && this.personIdApplyFilter(optionsRequired.filter)) {
      this.personId = config.personId;
      if (optionsRequired.unassign) this.personIdIsSet = false;
      else this.personIdIsSet = true;
    }
    if (
      config.fixPurchasable &&
      this.fixPurchasableApplyFilter(optionsRequired.filter)
    ) {
      this.fixPurchasable = config.fixPurchasable;
      if (optionsRequired.unassign) this.fixPurchasableIsSet = false;
      else this.fixPurchasableIsSet = true;
    }
    if (
      config.fixPurchasableState &&
      this.fixPurchasableStateApplyFilter(optionsRequired.filter)
    ) {
      this.fixPurchasableState = config.fixPurchasableState;
      if (optionsRequired.unassign) this.fixPurchasableStateIsSet = false;
      else this.fixPurchasableStateIsSet = true;
    }
    if (
      config.purchasableState &&
      this.purchasableStateApplyFilter(optionsRequired.filter)
    ) {
      this.purchasableState = config.purchasableState;
      if (optionsRequired.unassign) this.purchasableStateIsSet = false;
      else this.purchasableStateIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): FixLineItemRequestDTOTrackedI {
    const cloned = {} as FixLineItemRequestDTOTrackedI;
    if (
      this.lineItemIdIsSetDeep() &&
      this.lineItemIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.lineItemIdIsSet = true;
      cloned.lineItemId = this.lineItemId;
    } else {
      //cloned.lineItemIdIsSet = false
    }
    if (
      this.personIdIsSetDeep() &&
      this.personIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.personIdIsSet = true;
      cloned.personId = this.personId;
    } else {
      //cloned.personIdIsSet = false
    }
    if (
      this.fixPurchasableIsSetDeep() &&
      this.fixPurchasableApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.fixPurchasableIsSet = true;
      cloned.fixPurchasable = this.fixPurchasable;
    } else {
      //cloned.fixPurchasableIsSet = false
    }
    if (
      this.fixPurchasableStateIsSetDeep() &&
      this.fixPurchasableStateApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.fixPurchasableStateIsSet = true;
      cloned.fixPurchasableState = this.fixPurchasableState;
    } else {
      //cloned.fixPurchasableStateIsSet = false
    }
    if (
      this.purchasableStateIsSetDeep() &&
      this.purchasableStateApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.purchasableStateIsSet = true;
      cloned.purchasableState = this.purchasableState;
    } else {
      //cloned.purchasableStateIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): FixLineItemRequestDTOTrackedI {
    if (!this.lineItemIdApplyFilter(filter)) this.lineItemIdIsSet = false;

    if (!this.personIdApplyFilter(filter)) this.personIdIsSet = false;

    if (!this.fixPurchasableApplyFilter(filter))
      this.fixPurchasableIsSet = false;

    if (!this.fixPurchasableStateApplyFilter(filter))
      this.fixPurchasableStateIsSet = false;

    if (!this.purchasableStateApplyFilter(filter))
      this.purchasableStateIsSet = false;

    return this;
  }
  lineItemIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      FixLineItemRequestDTOMeta.lineItemId,
      FixLineItemRequestDTOMeta,
      this.lineItemId,
      this,
    );
  }
  lineItemIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.lineItemIdIsSet && this.lineItemIdApplyFilter(filter)) return true;

    return false;
  }
  personIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      FixLineItemRequestDTOMeta.personId,
      FixLineItemRequestDTOMeta,
      this.personId,
      this,
    );
  }
  personIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.personIdIsSet && this.personIdApplyFilter(filter)) return true;

    return false;
  }
  fixPurchasableApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      FixLineItemRequestDTOMeta.fixPurchasable,
      FixLineItemRequestDTOMeta,
      this.fixPurchasable,
      this,
    );
  }
  fixPurchasableIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.fixPurchasableIsSet && this.fixPurchasableApplyFilter(filter))
      return true;

    return false;
  }
  fixPurchasableStateApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      FixLineItemRequestDTOMeta.fixPurchasableState,
      FixLineItemRequestDTOMeta,
      this.fixPurchasableState,
      this,
    );
  }
  fixPurchasableStateIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.fixPurchasableStateIsSet &&
      this.fixPurchasableStateApplyFilter(filter)
    )
      return true;

    return false;
  }
  purchasableStateApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      FixLineItemRequestDTOMeta.purchasableState,
      FixLineItemRequestDTOMeta,
      this.purchasableState,
      this,
    );
  }
  purchasableStateIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.purchasableStateIsSet && this.purchasableStateApplyFilter(filter))
      return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.lineItemIdIsSetDeep(filter)) return true;
    if (this.personIdIsSetDeep(filter)) return true;
    if (this.fixPurchasableIsSetDeep(filter)) return true;
    if (this.fixPurchasableStateIsSetDeep(filter)) return true;
    if (this.purchasableStateIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
